export default "__VITE_ASSET__6720f5e8__"